import type { PartialDeep } from "type-fest";
import type { SearchDataModel } from "@searchui-searchforms/shared/canonicalizer";
import { invariant } from "@searchui-searchforms/shared/utils";
import { dataModelToQueryString, urlToDataModel } from "./canonicalizer";

/**
 * Normalizes a partial (or full) data model by round-tripping through the canonicalizer.
 * `dataModelToQueryString` → `urlToDataModel` ensures all defaults are filled in
 * and the model is in canonical form.
 */
export const normalizeDataModel = async (dataModel: PartialDeep<SearchDataModel>): Promise<SearchDataModel> => {
    const queryString = dataModelToQueryString(dataModel, "search");
    const { dataModel: normalized } = await urlToDataModel<SearchDataModel>(
        // Origin is arbitrary — canonicalizer only uses the path and query string
        `http://localhost/search?${queryString}`,
    );
    invariant(normalized, "Failed to normalize dataModel");
    return normalized;
};

export const normalizedDataModelQueryKey = (dataModel: PartialDeep<SearchDataModel> = {}) =>
    ["dataModel", "normalized", dataModelToQueryString(dataModel, "search")] as const;
